import React from 'react';
import s from '../About/About_us.module.css';
import logo from '../../images/header/logo.png';
import background from '../About/AboutImg/RetinaDisplay.png';
import Love from '../About/AboutImg/Love.png';
import Container from '../Container/Container';

export default function mask() {
  return (
    <div className={s.conteinerAccesories}>
      <Container>
        <div className={s.left_block}>
          <img src={Love} alt="" className={s.love} />
          <h2 className={s.Mask_title}>
            Чому обирають
            <img src={logo} alt="" className={s.Mask_logo} />
          </h2>

          <ul className={s.MaskAccessories}>
            <li className={s.list}>
              Стежимо за трендами геймінгу і постійно вдосконалюємося. Серед
              нашого асортименту ви точно знайдете аксесуари, які відповідають
              вашим вимогам.
            </li>
            <li className={s.list}>
              Дбаємо про те, щоб наша продукція була доступною для кожного. Ми
              даємо вам усі переваги сучасного геймінгу за помірною вартістю.
            </li>
            <li className={s.list}>
              Цінуємо якість товару, сервіс і клієнта. Наше завдання – надати
              вам повний спектр послуг з навчання по використанню та
              обслуговуванню пристрою.
            </li>
            <li className={s.list}>
              Геймінг – це цікаво і захоплююче з GamePRO.
            </li>
          </ul>
        </div>
      </Container>
      <div className={s.right_block}>
        <img src={background} alt="" className={s.Img_right_block} />
      </div>
    </div>
  );
}
